import request from 'components/Utils/Request';
import axios from 'axios';
const { REACT_APP_API_URL } = process.env;
export const CASH_COLLECTION_REPORT_REQUEST = 'CASH_COLLECTION_REPORT_REQUEST';
export const CASH_COLLECTION_REPORT_SUCCESS = 'CASH_COLLECTION_REPORT_SUCCESS';
export const CASH_COLLECTION_REPORT_FAILURE = 'CASH_COLLECTION_REPORT_FAILURE';

    export const cashCollectionReportPDFRequest = () => ({
      type: CASH_COLLECTION_REPORT_REQUEST
    });
    export const cashCollectionReportPDFSuccess = payload => ({
      type: CASH_COLLECTION_REPORT_SUCCESS,
      payload
    });
    export const cashCollectionReportPDFFailure = payload => ({
      type: CASH_COLLECTION_REPORT_FAILURE,
      payload
    });
  
  export const cashCollectionReportDataAction = payload => {
    return {
      type: 'CASHCOLLECTIONREPORTDATA',
      payload
    };
  };

export const cashCollectionReportPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
  return dispatch => {
    dispatch(cashCollectionReportPDFRequest());
    axios
      .post(
        `${REACT_APP_API_URL}/cash-collection-report`,
        payload,
        {
          responseType: 'blob',
          headers: headers,
        }
      )
      .then(response => {
        // if (response.status === 200 && response.data) {
          if (response.headers['content-type'] === 'application/pdf') {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl, '_blank');

          dispatch(cashCollectionReportPDFSuccess());
        } else {
          errorCallback("Failed to generate PDF");
          dispatch(cashCollectionReportPDFFailure());
        }
      })
      .catch(error => {
        console.error("Error downloading PDF:", error);
        errorCallback("Error occurred while downloading PDF");
        dispatch(cashCollectionReportPDFFailure());
      });
  };
};
